if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');

      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') { return; }

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          updateCart(response);
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-product-form-error-message-wrapper]');

      if (!this.errorMessageWrapper) return;

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-product-form-error-message]');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

const PENDING_VARIANT_STORAGE_KEY = 'yns_pdp_pending_variant';

function normalizeProductHandleFromPathname(pathname) {
  const handle = pathname.split('/').filter(Boolean).pop() || '';
  return handle.replace(/-[1-5]$/, '');
}

function readPendingVariantCookie() {
  const match = document.cookie.match(/(?:^|; )yns_pdp_pending_variant=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function clearPendingVariantStores() {
  try {
    sessionStorage.removeItem(PENDING_VARIANT_STORAGE_KEY);
  } catch (_) {}
  document.cookie = 'yns_pdp_pending_variant=;path=/;max-age=0;SameSite=Lax';
}

function parsePendingVariantEntry(raw) {
  if (!raw) return null;
  try {
    const o = JSON.parse(raw);
    if (o && o.v != null && /^\d+$/.test(String(o.v))) {
      return { h: o.h != null ? String(o.h) : null, v: String(o.v) };
    }
  } catch (_) {}
  if (/^\d+$/.test(raw)) return { h: null, v: raw };
  return null;
}

function getVariantIdFromMergedPdpReferrer() {
  try {
    const ref = document.referrer;
    if (!ref) return null;
    const u = new URL(ref);
    if (!u.pathname.includes('/products/')) return null;
    const v = u.searchParams.get('variant');
    if (!v || !/^\d+$/.test(v)) return null;
    const currentBase = normalizeProductHandleFromPathname(window.location.pathname);
    const referrerBase = normalizeProductHandleFromPathname(u.pathname);
    if (currentBase !== referrerBase) return null;
    return v;
  } catch (_) {
    return null;
  }
}

function consumePendingVariantId() {
  const base = normalizeProductHandleFromPathname(window.location.pathname);
  let raw = null;
  try {
    raw = sessionStorage.getItem(PENDING_VARIANT_STORAGE_KEY);
  } catch (_) {}
  if (!raw) raw = readPendingVariantCookie();

  let entry = parsePendingVariantEntry(raw);
  if (entry && entry.h != null && entry.h !== base) {
    entry = null;
  }

  if (!entry) {
    const fromRef = getVariantIdFromMergedPdpReferrer();
    if (fromRef) return fromRef;
    return null;
  }

  return entry.v;
}

const createMainMediaSwiper = (gallery, originalGalleryContent) => {
  const existingSwiper = document.querySelector('[data-product-gallery-swiper].swiper-initialized');

  if (existingSwiper && existingSwiper.swiper) {
    existingSwiper.swiper.destroy(true, true);
  }

  if (gallery && originalGalleryContent !== null) {
    gallery.innerHTML = originalGalleryContent;
  }

  return new Swiper('[data-product-gallery-swiper]', {
    zoom: true,
    effect: 'fade',
    crossFade: true,
    pagination: {
      el: '[data-product-gallery-swiper-pagination]',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '[data-product-gallery-swiper-next]',
      prevEl: '[data-product-gallery-swiper-prev]',
    },
    thumbs: {
      swiper: document.querySelector('[data-product-gallery-thumbnails]')
    },
    on: {
      slideChange: function (swiper) {
        swiper.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) {
            video.pause();
          }
        });

        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide?.querySelector('video');

        if (activeVideo) {
          activeVideo.play();
        }
      },
    },
  });
}

async function updateCart(response) {
  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (response.sections) {
    this.cart.renderContents(response);
  } else {
    const cartDrawerSection = await fetch(window.location.pathname + '?sections=cart-drawer').then(res => res.json())

    const object = {
      sections: {
        ...cartDrawerSection
      }
    }

    this.cart.renderContents(object);
  }

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.open();
    this.cart.classList.remove('is-empty');
  }

  fetch('/cart.js', {
    method: 'GET',
    cache: 'no-cache'
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then((cart) => {
    document.querySelectorAll('.buy-button-wrapper .added-success').forEach(success => {
      success.style.display = 'block';
      setTimeout(() => {
        success.style.display = 'none';
      }, 3000);
    });

    const itemCountElements = document.querySelectorAll('.minicart-quantity .item-count');
    const v2ItemCountElements = document.querySelectorAll('.v2-item-count');
    const v2MinicartQuantityBadges = document.querySelectorAll('.v2-minicart-quantity');

    itemCountElements.forEach((itemCountElement) => {
      itemCountElement.textContent = cart.item_count;
    });

    // Update v2 header cart badges
    v2ItemCountElements.forEach((itemCountElement) => {
      itemCountElement.textContent = cart.item_count;
    });

    // Show/hide v2 badge based on cart item count
    v2MinicartQuantityBadges.forEach(badge => {
      if (cart.item_count > 0) {
        badge.style.display = 'flex';
        badge.removeAttribute('data-empty');
      } else {
        badge.style.display = 'none';
        badge.setAttribute('data-empty', 'true');
      }
    });

    // Mobile: adjust padding-right of .v2-top-banner-wrapper based on cart state
    const isMobile = window.innerWidth <= 1024;
    const topBannerWrapper = document.querySelector('.v2-top-banner-wrapper');
    if (isMobile && topBannerWrapper) {
      if (cart.item_count === 0) {
        topBannerWrapper.style.paddingRight = '0';
      } else {
        topBannerWrapper.style.paddingRight = '';
      }
    }

    if (cart.item_count >= 1) {
      this.cart.classList.remove('is-empty')
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

addSwiperCssJs();

const gallery = document.querySelector('[data-product-gallery] .swiper-wrapper');
const originalGalleryContent = gallery?.innerHTML;
this.mainMediaSwiper = createMainMediaSwiper(gallery, originalGalleryContent);

this.mainMediaSwiper.on('slideChange', (swiper) => {
  const slidesWithVideos = swiper.slides.filter((slide) => slide.querySelector('video'));

  slidesWithVideos.forEach((slideWithVideo) => {
    const video = slideWithVideo.querySelector('video');
    video.pause();
  });
});

const createThumbnailSwiper = (thumbnails, originalThumbnails) => {
  const existingSwiper = document.querySelector('[data-product-gallery-thumbnails].swiper-initialized');
  if (existingSwiper && existingSwiper.swiper) {
    existingSwiper.swiper.destroy(true, true);
  }

  if (thumbnails && originalThumbnails !== null) {
    thumbnails.innerHTML = originalThumbnails;
  }

  return new Swiper('[data-product-gallery-thumbnails]', {
    keyboard: true,
    slidesPerView: 5,
    slideToClickedSlide: true,
    clickable: true,
    spaceBetween: 8,
    navigation: {
      nextEl: '[data-product-gallery-thumbnails] .swiper-button-next',
      prevEl: '[data-product-gallery-thumbnails] .swiper-button-prev',
    }
  });
};

const thumbnails = document.querySelector('[data-product-gallery-thumbnails] .swiper-wrapper');
const originalThumbnails = thumbnails?.innerHTML;
this.thumbnailSwiper = createThumbnailSwiper(thumbnails, originalThumbnails);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.gallery = document.querySelector('[data-product-gallery] .swiper-wrapper');
    this.originalGalleryContent = this.gallery?.innerHTML;
    this.thumbnailsWrapper = document.querySelector('[data-product-gallery-thumbnails-wrapper]');
    this.thumbnails = document.querySelector('[data-product-gallery-thumbnails] .swiper-wrapper');
    this.originalThumbnails = this.thumbnails?.innerHTML;
    this.filterButtons = this.querySelectorAll('[data-product-swatch-filter]');
    this.currentlyFilteredEl = this.querySelector('[data-product-swatch-currently-filtered]');
    this.clearFiltersButton = this.querySelector('[data-product-clear-filters-button]');
    this.colorSwatchesWrapper = document.querySelector('[data-product-swatches-wrapper]');
    this.colorSwatches = document.querySelectorAll('[data-product-color-swatch]');
    this.select = this.querySelector('[data-product-variant-select]');
    this._scrollInitialVariantIntoViewPending = false;
  }

  connectedCallback() {
    this.filterButtons.forEach((button) => button.addEventListener('click', () => this.filterSwatches(button)))

    if (this.clearFiltersButton) {
      this.clearFiltersButton.addEventListener('click', () => this.clearFilters())
    }

    checkOutOfStockInventory();

    this.checkThumbnailLength();
    this.sortSoldoutSwatches();
    this.validateFilterButtons();
    

    let currentVariantID = null;
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('variant')) {
      currentVariantID = urlParams.get('variant');
      clearPendingVariantStores();
    } else {
      currentVariantID = consumePendingVariantId();
    }

    let scrollInitialVariantIntoView = false;

    if (currentVariantID) {
      const currentVariantInput = this.querySelector(`[variant-id="${currentVariantID}"]`);

      if (currentVariantInput && currentVariantInput.type === 'radio') {
        currentVariantInput.checked = true;
        scrollInitialVariantIntoView = true;
      }

      clearPendingVariantStores();
    }

    this._scrollInitialVariantIntoViewPending = scrollInitialVariantIntoView;
    this.dispatchEvent(new Event('change'));

    this.setActiveVariantVisible();
    this.filterSwatches();
  }

  scrollSelectedVariantOptionIntoView() {
    const input = this.querySelector('input[type="radio"]:checked');
    if (!input) return;

    const target =
      input.closest('[data-product-color-swatch]') ||
      input.closest('.product__size-label-wrapper');

    if (!target) return;

    target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
  }

  checkThumbnailLength() {
    if (this.thumbnailsWrapper?.querySelectorAll('[data-thumbnail-color].initial-load').length >= 5) {
      this.thumbnailsWrapper?.classList.remove('less-than-5');
    } else {
      this.thumbnailsWrapper?.classList.add('less-than-5');
    }
  }

  onVariantChange() {
    if (this.mainMediaSwiper) {
      this.mainMediaSwiper.destroy(true, true);
    }

    if (this.thumbnailSwiper && this.querySelectorAll('.swiper-container.thumbnails').length > 0) {
      this.thumbnailSwiper.destroy(true, true);
    }

    if (this.gallery && this.originalGalleryContent) {
      this.gallery.innerHTML = this.originalGalleryContent;
    }
    
    if (this.thumbnails && this.originalThumbnails) {
      this.thumbnails.innerHTML = this.originalThumbnails;
    }

    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateVariantContent();
    this.sortSoldoutSwatches();
    this.updateStatusMessage();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateURL();
      this.filterMedia();
      this.updateVariantInput();
    }

    requestAnimationFrame(() => {
      this.mainMediaSwiper = createMainMediaSwiper(this.gallery, null);
      this.thumbnailSwiper = createThumbnailSwiper(this.thumbnails, null);

      if (this._scrollInitialVariantIntoViewPending) {
        this._scrollInitialVariantIntoViewPending = false;
        requestAnimationFrame(() => this.scrollSelectedVariantOptionIntoView());
      }
    });
  }

  updateStatusMessage() {
    const tooltip = document.querySelector('[data-product-variant-badge-tooltip]');
    const tooltipText = tooltip?.querySelector('[data-product-variant-badge-tooltip-text]');
    const variants = tooltip?.getAttribute('data-variants') ? JSON.parse(tooltip.getAttribute('data-variants')) : null;

    if (!tooltip || !variants) { return; }

    const matchingVariant = variants.find((variant) => variant.id == this.currentVariant.id);

    if (matchingVariant) {
      tooltip.classList.remove('hidden');
      tooltipText.innerText = matchingVariant.message;
    } else {
      tooltip.classList.add('hidden');
    }
  }

  filterSwatches(button) {
    if (button) {
      button.classList.toggle('active');
    }

    const activeFilters = Array.from(this.filterButtons).filter((button) => button.classList.contains('active'));

    this.currentlyFilteredEl.innerHTML = '';

    if (this.colorSwatches && !this._swatchHoverPreviewBound) {
      this._swatchHoverPreviewBound = true;
      const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const color_el = document.querySelector('#option-label-Color + .product__current-option');
      const mainProductContainer = this.closest('[data-main-product-wrapper]');
      const checkedInput = () => this.querySelector('input[name="Color"]:checked');
      const active_color = () => checkedInput()?.value ?? '';

      const statusPrefix = 'status';
      const badgeStatusHandles = ['new', 'free-gift', 'limited-edition', 'coming-soon', 'pre-order', 'price-drop', 'clearance', 'discontinued', 'best-seller', 'sale', 'out-of-stock', 'low-stock'];

      this.colorSwatches.forEach((swatch) => {
        const hover_color = swatch.getAttribute('data-color');
        const variantStatuses = swatch.getAttribute('data-variant-statuses') || '';

        if (!supportsHover) return;

        swatch.addEventListener('mouseover', () => {
          const previewDiscontinuedClass = 'preview-discontinued';
          const previewExclusiveClass = 'preview-exclusive';
          const isOtherVariant = active_color() !== hover_color;
          if (isOtherVariant) {
            color_el.innerHTML = hover_color;
            color_el.classList.add('user-hovering');
          } else {
            color_el.classList.remove('user-hovering');
            mainProductContainer?.classList.remove(previewDiscontinuedClass);
            mainProductContainer?.classList.remove(previewExclusiveClass);
            mainProductContainer?.classList.remove('selection-discontinued-hover-lock');
            mainProductContainer?.classList.remove('selection-price-hover-lock');
          }
          if (mainProductContainer && isOtherVariant) {
            const selectedInput = checkedInput();
            const selectedStatusesAttr =
              selectedInput?.closest('[data-product-color-swatch]')?.getAttribute('data-variant-statuses') ?? '';
            const selectedStatuses = selectedStatusesAttr
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean);
            const selectedMetafield = this.getPreviewMetafieldData(
              selectedInput?.getAttribute('variant-id')?.trim()
            );
            const selectedHasExclusive = typeof selectedMetafield?.exclusive === 'string'
              && selectedMetafield.exclusive.trim().length > 0;
            const selectedHidesPrice = selectedStatuses.some((s) => s.toLowerCase() === 'discontinued')
              || selectedHasExclusive
              || selectedMetafield?.stock === 'not-in-market';

            badgeStatusHandles.forEach((handle) => {
              mainProductContainer.classList.remove(`${statusPrefix}-${handle}`);
            });
            mainProductContainer.classList.remove(previewDiscontinuedClass);
            mainProductContainer.classList.remove(previewExclusiveClass);
            mainProductContainer.classList.remove('selection-discontinued-hover-lock');
            mainProductContainer.classList.toggle('selection-price-hover-lock', selectedHidesPrice);
            const statuses = variantStatuses.split(',').map((s) => s.trim()).filter(Boolean);
            const hasDiscontinuedPreview = statuses.some((s) => s.toLowerCase() === 'discontinued');
            const statusesWithoutDiscontinued = statuses.filter((s) => s.toLowerCase() !== 'discontinued');
            if (!mainProductContainer.classList.contains('product--retailer-exclusive')) {
              statusesWithoutDiscontinued.forEach((handle) => mainProductContainer.classList.add(`${statusPrefix}-${handle}`));
              if (hasDiscontinuedPreview) {
                mainProductContainer.classList.add(previewDiscontinuedClass);
              }
            }
            const savingsEl = mainProductContainer.querySelector('[data-product-sale-savings]');
            if (savingsEl) {
              if (statuses.includes('sale')) {
                const price = parseFloat(swatch.getAttribute('data-variant-price'));
                const compareAt = parseFloat(swatch.getAttribute('data-variant-compare-at-price'));
                if (Number.isFinite(price) && Number.isFinite(compareAt) && compareAt > price) {
                  const savingsPercentage = 100 - ((price / compareAt) * 100);
                  savingsEl.textContent = `${savingsPercentage.toFixed(2).split('.')[0]}%`;
                } else {
                  savingsEl.textContent = '';
                }
              } else {
                savingsEl.textContent = '';
              }
            }
            if (statuses.includes('low-stock')) {
              const stockNum = swatch.getAttribute('data-variant-stock');
              mainProductContainer.querySelectorAll('[data-product-low-stock]').forEach((el) => {
                el.textContent = stockNum != null ? stockNum : '';
              });
            }

            const previewVariantId = swatch.querySelector('input[type="radio"]')?.getAttribute('variant-id')?.trim();
            if (previewVariantId) {
              this._hoverPreviewVariantId = previewVariantId;
              this.previewVariantBuyButtons(mainProductContainer, previewVariantId);
            }
          }
        });

        swatch.addEventListener('mouseout', () => {
          this._hoverPreviewVariantId = null;
          color_el.innerHTML = active_color();
          color_el.classList.remove('user-hovering');
          if (mainProductContainer) this.updateVariantContent({ skipPriceMarkup: true });
        });

        swatch.addEventListener('click', () => {
          color_el.classList.remove('user-hovering');
        });
      })
    }
    if (activeFilters.length >= 1) {
      this.colorSwatches.forEach((swatch) => swatch.classList.add('hidden'));
      this.colorSwatches.forEach((swatch) => swatch.classList.remove('filtered'));

      activeFilters.forEach((filter, index) => {
        const filterColor = filter.getAttribute('data-product-swatch-filter');

        this.colorSwatches.forEach((swatch) => {

          const colorFamilyList = JSON.parse(swatch.dataset.colorFamilyList || '[]');

          if (colorFamilyList.includes(filterColor)) {
            swatch.classList.remove('hidden');
            swatch.classList.add('filtered');
          }
        });

        const filterName = filter.dataset.productSwatchFilter;
        this.currentlyFilteredEl.innerHTML += `${filterName}${activeFilters.length > (index + 1) ? ', ' : ''}`;
      });

      const filteredSwatches = Array.from(this.colorSwatches).filter((swatch) => swatch.classList.contains('filtered'));
      this.updateSwatchRows(filteredSwatches);
      this.clearFiltersButton.classList.remove('hidden');
    } else {
      this.colorSwatches.forEach((swatch) => swatch.classList.remove('hidden'));
      const swatches = Array.from(this.colorSwatches).filter((swatch) => !swatch.querySelector('.out-of-stock'));
      this.updateSwatchRows(swatches);
      this.clearFiltersButton.classList.add('hidden');
    }
  }

  clearFilters() {
    this.filterButtons.forEach((button) => button.classList.remove('active'));
    this.colorSwatches.forEach((swatch) => swatch.classList.remove('hidden'));
    this.updateSwatchRows(this.colorSwatches);
    this.clearFiltersButton.classList.add('hidden');
    this.currentlyFilteredEl.innerHTML = '';
  }

  validateFilterButtons() {
    this.filterButtons.forEach((button) => {
      const filterColor = button.getAttribute('data-product-swatch-filter');
      let hasMatchingSwatches = false;

      this.colorSwatches.forEach((swatch) => {

        const colorFamilyList = JSON.parse(swatch.dataset.colorFamilyList || '[]');

        if (colorFamilyList.includes(filterColor)) {
          hasMatchingSwatches = true;
        }
      });

      button.classList.toggle('hidden', !hasMatchingSwatches)
    });
  }

  setActiveVariantVisible() {
    if (!this.colorSwatchesWrapper) { return; }

    const checkedInput = this.colorSwatchesWrapper.querySelector('input[type="radio"]:checked');
    
    if (checkedInput) {
      const selectedSwatch = checkedInput.closest('[data-product-color-swatch]') || checkedInput;
      
      selectedSwatch.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

  updateSwatchRows(swatches) {
    if (swatches && swatches.length >= 20) {
      this.colorSwatchesWrapper.classList.add('three-rows');
    } else if (swatches && swatches.length >= 10) {
      this.colorSwatchesWrapper.classList.add('two-rows');
    } else {
      this.colorSwatchesWrapper.classList.remove('two-rows', 'three-rows');
    }
  }

  getSwatchSortPriority(swatch) {
    const statuses = (swatch.getAttribute('data-variant-statuses') || '')
      .split(',')
      .map((status) => status.trim().toLowerCase())
      .filter(Boolean);
    const hasStatus = (status) => statuses.includes(status);
    const isOutOfStock = Boolean(swatch.querySelector('.out-of-stock'));

    // Priority 1 – New
    if (hasStatus('new')) return 1;

    // Priority 6 – Discontinued
    if (hasStatus('discontinued')) return 6;

    // Priority 5 – Retailer Exclusive
    if (hasStatus('retailer-exclusive') || hasStatus('exclusive')) return 5;

    // Priority 3 – Clearance (in stock first, then clearance OOS)
    if (hasStatus('clearance')) return isOutOfStock ? 3.5 : 3;

    // Priority 2 – Empty status, in stock
    // Priority 4 – Empty status, out of stock
    return isOutOfStock ? 4 : 2;
  }

  sortSoldoutSwatches() {
    if (!this.colorSwatchesWrapper || !this.colorSwatches.length) { return; }

    const sortedSwatches = Array.from(this.colorSwatches)
      .map((swatch, index) => ({
        swatch,
        index,
        priority: this.getSwatchSortPriority(swatch),
      }))
      .sort((a, b) => a.priority - b.priority || a.index - b.index)
      .map(({ swatch }) => swatch);

    const inStockSwatches = sortedSwatches.filter((swatch) => !swatch.querySelector('.out-of-stock'));
    const activeFilters = Array.from(this.filterButtons).filter((button) => button.classList.contains('active'));

    if (activeFilters.length) {
      this.filterSwatches();
    } else {
      this.updateSwatchRows(inStockSwatches);
    }

    this.colorSwatchesWrapper.innerHTML = '';
    sortedSwatches.forEach((swatch) => this.colorSwatchesWrapper.appendChild(swatch));
  }

  updateOptions() {
    this.options = [];

    const selects = Array.from(this.querySelectorAll('select'));
    const radios = Array.from(this.querySelectorAll('input[type="radio"]:checked'));

    selects.forEach((select) => {
      this.options.push(select.value);
    });

    radios.forEach((radio) => {
      this.options.push(radio.value);
    });
  }

  filterMedia() {
    // if (!this.closest('.product')?.querySelector('[data-product-swatches-wrapper]')) { return; }

    let selected_variant = this.currentVariant?.featured_media?.alt;

    if (!selected_variant) { return; }

    let selected_attribute = '[data-thumbnail-color="' + selected_variant + '"]';
    let all_variants = '[data-thumbnail-color="All Variants"]';

    document.querySelectorAll('[data-thumbnail-color]').forEach(function (el) {
      el.style.display = 'none';
      el.classList.add('hidden');
    });

    if (selected_variant) {
      let elementsToReposition = Array.from(document.querySelectorAll(selected_attribute));

      elementsToReposition.reverse().forEach(function (el) {
        el.style.display = 'block';
        el.classList.remove('hidden');

        let parent = el.parentNode;

        parent.removeChild(el);
        parent.insertBefore(el, parent.firstChild);
      });
    }

    document.querySelectorAll(all_variants).forEach(function (el) {
      el.style.display = 'block';
      el.classList.remove('hidden');
    });

    document.querySelectorAll('[data-thumbnail-color]').forEach(function (el) {
      if (!el.classList.contains('hidden')) { return; }
      el.remove();
    });

    if (this.thumbnailsWrapper?.querySelectorAll('[data-thumbnail-color]').length >= 5) {
      this.thumbnailsWrapper?.classList.remove('less-than-5');
    } else {
      this.thumbnailsWrapper?.classList.add('less-than-5');
    }
  }

  addToCartButtonTextFor(metafieldData, price) {
    if (metafieldData.pre_order) {
      return 'Pre-Order Now';
    }

    return `${formatMoney(price, '${{amount}}')} —  Add to Cart`;
  }

  isComingSoonVariant(metafieldData) {
    return typeof metafieldData?.variant_status === 'string'
      && metafieldData.variant_status.includes('Coming Soon');
  }

  isDebugVariant(metafieldData) {
    return typeof metafieldData?.variant_status === 'string'
      && metafieldData.variant_status.includes('Debug');
  }

  isDiscontinuedVariant(metafieldData) {
    return typeof metafieldData?.variant_status === 'string'
      && metafieldData.variant_status.toLowerCase().includes('discontinued');
  }

  applyDiscontinuedAvailability(mainProductContainer, inventoryElements) {
    const { oosInventoryEl, inStockInventoryEl, warningInventoryEl, bisForm } = inventoryElements;

    mainProductContainer?.classList.remove('status-out-of-stock', 'status-low-stock');
    oosInventoryEl?.setAttribute('hidden', true);
    inStockInventoryEl?.setAttribute('hidden', true);
    warningInventoryEl?.setAttribute('hidden', true);
    bisForm?.classList.add('disable-back-in-stock');
    this.toggleAddButton(true, window.variantStrings?.soldOut || 'Sold out', true);
  }

  getPreviewMetafieldData(variantId) {
    if (!variantId) return null;

    const metafieldData = this.getVariantMetafieldData();
    return metafieldData?.[0]?.[variantId.toString()] ?? null;
  }

  applySelectedVariantExclusiveMessaging(mainProductContainer) {
    if (!mainProductContainer) return;

    const exclusiveWrapper = mainProductContainer.querySelector('.product__exclusive-wrapper');
    const selectedMetafield = this.currentVariant
      ? this.getPreviewMetafieldData(this.currentVariant.id)
      : null;
    const exclusiveMessage = typeof selectedMetafield?.exclusive === 'string'
      ? selectedMetafield.exclusive.trim()
      : '';
    const hasExclusiveMessage = exclusiveMessage.length > 0;

    if (exclusiveWrapper) {
      exclusiveWrapper.innerHTML = hasExclusiveMessage
        ? `<p class='product__text exclusive_message'>${exclusiveMessage}</p>`
        : '';
    }

    mainProductContainer.classList.toggle('status-exclusive', hasExclusiveMessage);
    if (hasExclusiveMessage) {
      mainProductContainer.classList.remove('status-out-of-stock', 'status-low-stock');
    }
  }

  getPreviewVariant(variantId) {
    if (!variantId) return null;

    return this.getVariantData().find((variant) => variant.id == variantId) ?? null;
  }

  updateBisFormForVariant(mainProductContainer, isComingSoon, variantId) {
    const bisForm = mainProductContainer?.querySelector('.product__bis-form');
    if (!bisForm) return;

    const resolvedVariantId = variantId ?? this.currentVariant?.id;

    bisForm.querySelector('.product__bis-form-heading-coming-soon')
      ?.classList.toggle('hidden', !isComingSoon);
    bisForm.querySelector('.product__bis-form-heading-default')
      ?.classList.toggle('hidden', isComingSoon);

    const bisVariantIdInput = bisForm.querySelector(':scope > input.product-variant-id');

    if (isComingSoon) {
      if (bisVariantIdInput && resolvedVariantId) {
        bisVariantIdInput.value = resolvedVariantId;
      } else if (resolvedVariantId) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.className = 'product-variant-id';
        input.value = resolvedVariantId;
        bisForm.prepend(input);
      }
    } else {
      bisVariantIdInput?.remove();
    }
  }

  updateInventoryForComingSoon(mainProductContainer, isComingSoon) {
    const comingSoonInventoryEl = mainProductContainer?.querySelector('.coming-soon.inventory');
    if (!comingSoonInventoryEl) return;

    if (isComingSoon) {
      comingSoonInventoryEl.removeAttribute('hidden');
      mainProductContainer.querySelector('.out-of-stock.inventory')?.setAttribute('hidden', true);
      mainProductContainer.querySelector('.in-stock.inventory')?.setAttribute('hidden', true);
      mainProductContainer.querySelector('.warning-stock.inventory')?.setAttribute('hidden', true);
    } else {
      comingSoonInventoryEl.setAttribute('hidden', true);
    }
  }

  syncBuyButtons(metafieldData, mainProductContainer, options = {}) {
    const requestedVariantId = options.variantId ?? this.currentVariant?.id;
    const isComingSoon = this.isComingSoonVariant(metafieldData);
    const isDiscontinued = this.isDiscontinuedVariant(metafieldData);
    const bisForm = mainProductContainer?.querySelector('.product__bis-form');
    const bisDisabled = metafieldData?.disable_back_in_stock === 'true';

    this.updateBisFormForVariant(mainProductContainer, isComingSoon, requestedVariantId);
    this.updateInventoryForComingSoon(mainProductContainer, isComingSoon);

    if (isDiscontinued) {
      mainProductContainer?.classList.remove('status-out-of-stock', 'status-low-stock');
    }

    if (isComingSoon) {
      mainProductContainer?.classList.remove('status-out-of-stock');
      mainProductContainer?.classList.toggle('disable-back-in-stock', bisDisabled);
      bisForm?.classList.toggle('disable-back-in-stock', bisDisabled);

      const bisFormFormEl = bisForm?.querySelector('#bis_form');
      if (bisFormFormEl) {
        bisFormFormEl.style.display = 'block';
      }

      const bisFormSuccess = bisForm?.querySelector('.product__bis-success-message');
      if (bisFormSuccess) {
        bisFormSuccess.style.display = 'none';
      }
    }

    if (!mainProductContainer?.querySelector('.product__buy-buttons-wrapper')) return;

    this.updateVariantInput(requestedVariantId);

    if (isComingSoon || isDiscontinued || this.isDebugVariant(metafieldData)) {
      this.toggleAddButton(true, window.variantStrings?.soldOut || 'Sold out', true);
    }
  }

  updateSkuDisplay(metafieldData) {
    const skuElements = document.querySelectorAll('[data-product-sku]');

    skuElements.forEach((skuElement) => {
      skuElement.textContent = metafieldData?.sku ?? '';
    });
  }

  previewVariantBuyButtons(mainProductContainer, variantId) {
    if (this._hoverPreviewVariantId != variantId) return;

    const previewMetafield = this.getPreviewMetafieldData(variantId);
    const previewVariant = this.getPreviewVariant(variantId);
    const inventoryElements = {
      oosInventoryEl: mainProductContainer.querySelector('.out-of-stock.inventory'),
      inStockInventoryEl: mainProductContainer.querySelector('.in-stock.inventory'),
      warningInventoryEl: mainProductContainer.querySelector('.warning-stock.inventory'),
      bisForm: mainProductContainer.querySelector('.product__bis-form'),
      availableInEl: document.querySelector('.product__available-in'),
      exclusiveWrapper: mainProductContainer.querySelector('.product__exclusive-wrapper'),
    };
    const isComingSoon = this.isComingSoonVariant(previewMetafield);
    const isDiscontinued = this.isDiscontinuedVariant(previewMetafield)
      || mainProductContainer.classList.contains('preview-discontinued');
    const hasExclusiveMessage = typeof previewMetafield?.exclusive === 'string'
      && previewMetafield.exclusive.trim().length > 0;

    this.updateSkuDisplay(previewMetafield);
    this.syncBuyButtons(previewMetafield, mainProductContainer, { variantId });

    if (this._hoverPreviewVariantId != variantId) return;

    if (isDiscontinued) {
      this.applyDiscontinuedAvailability(mainProductContainer, inventoryElements);
    } else if (!isComingSoon && !hasExclusiveMessage && previewMetafield?.hasOwnProperty('stock')) {
      this.applyStockAvailability(
        previewMetafield,
        mainProductContainer,
        inventoryElements,
        previewVariant,
        { skipExclusiveUpdates: true }
      );
    }

    if (hasExclusiveMessage) {
      mainProductContainer.classList.add('preview-exclusive');
      mainProductContainer.classList.remove('status-out-of-stock', 'status-low-stock');
    } else {
      mainProductContainer.classList.remove('preview-exclusive');
    }

    this.applySelectedVariantExclusiveMessaging(mainProductContainer);
  }

  applyStockAvailability(metafieldData, mainProductContainer, inventoryElements, variantForPrice, options = {}) {
    const {
      oosInventoryEl,
      inStockInventoryEl,
      warningInventoryEl,
      bisForm,
      availableInEl,
      exclusiveWrapper,
    } = inventoryElements;
    const priceVariant = variantForPrice || this.currentVariant;
    const skipExclusiveUpdates = options.skipExclusiveUpdates === true;

    if (!metafieldData?.hasOwnProperty('stock')) return;

    var stock = metafieldData['stock'];
    const quantityInput = document.querySelector('[data-product-quantity-input]');

    if (quantityInput) {
      quantityInput.setAttribute('max', stock);
      quantityInput.value = stock < 1 || this.isDebugVariant(metafieldData) ? 0 : 1;
    }

    mainProductContainer.classList.toggle('disable-back-in-stock', metafieldData.disable_back_in_stock === 'true');

    if (stock != 'not-in-market') {
      stock = parseInt(metafieldData['stock']);

      if (!skipExclusiveUpdates) {
        if (exclusiveWrapper) {
          exclusiveWrapper.innerHTML = '';
        }

        mainProductContainer.classList.remove('status-exclusive');
      }

      if (this.isDebugVariant(metafieldData)) {
        mainProductContainer.classList.add('status-out-of-stock');
        oosInventoryEl && oosInventoryEl.removeAttribute('hidden');
        inStockInventoryEl && inStockInventoryEl.setAttribute('hidden', true);
        warningInventoryEl && warningInventoryEl.setAttribute('hidden', true);

        this.toggleAddButton(true, this.addToCartButtonTextFor(metafieldData, priceVariant?.price), true);

        if (bisForm) {
          bisForm.classList.add('disable-back-in-stock');
        }
      } else if (stock < 1) {
        mainProductContainer.classList.add('status-out-of-stock');
        oosInventoryEl && oosInventoryEl.removeAttribute('hidden');
        inStockInventoryEl && inStockInventoryEl.setAttribute('hidden', true);
        warningInventoryEl && warningInventoryEl.setAttribute('hidden', true);

        this.toggleAddButton(true, this.addToCartButtonTextFor(metafieldData, priceVariant?.price), true);

        var bisOverride = metafieldData['disable_back_in_stock'];
        if (bisForm) {
          if (bisOverride === undefined) {
            bisForm.classList.remove('disable-back-in-stock');
          } else if (bisOverride == 'true') {
            bisForm.classList.add('disable-back-in-stock');
          } else {
            bisForm.classList.remove('disable-back-in-stock');
          }
        }
      } else if (stock > 30) {
        mainProductContainer.classList.remove('status-out-of-stock');

        oosInventoryEl && oosInventoryEl.setAttribute('hidden', true);
        inStockInventoryEl && inStockInventoryEl.removeAttribute('hidden');
        warningInventoryEl && warningInventoryEl.setAttribute('hidden', true);

        this.toggleAddButton(false, this.addToCartButtonTextFor(metafieldData, priceVariant?.price), true);
      } else {
        mainProductContainer.classList.remove('status-out-of-stock');

        oosInventoryEl && oosInventoryEl.setAttribute('hidden', true);
        inStockInventoryEl && inStockInventoryEl.setAttribute('hidden', true);
        warningInventoryEl && warningInventoryEl.removeAttribute('hidden');

        mainProductContainer.classList.add('status-low-stock');

        const productLowStockTextEls = mainProductContainer.querySelectorAll('[data-product-low-stock]');

        productLowStockTextEls.forEach((productLowStockTextEl) => {
          productLowStockTextEl.innerText = stock;
        });

        this.toggleAddButton(false, this.addToCartButtonTextFor(metafieldData, priceVariant?.price), true);
      }
    } else {
      if (metafieldData?.product_type != 'Pattern') {
        if (metafieldData.inventories) {
          var availableIn = 'Available Only In';

          if (metafieldData.inventories.includes('Bassett')) {
            availableIn = availableIn + ' Canada';
          }
          if (metafieldData.inventories.includes('Albany')) {
            availableIn = availableIn + ' United States';
          }

          availableIn = availableIn.replace('Canada United States', 'Canada and United States');
          availableInEl.textContent = availableIn;
          availableInEl.classList.add('has-data');
        } else {
          availableInEl.classList.remove('has-data');
        }

        mainProductContainer.classList.add('status-not-in-market');

        if (!skipExclusiveUpdates && exclusiveWrapper) {
          exclusiveWrapper.innerHTML = `<p class='product__text exclusive_message'>Not available in ${metafieldData['market']}</p>`;
        }
      }
    }

    const warningInventorySpanEl = warningInventoryEl?.querySelector('span');

    if (warningInventorySpanEl) {
      warningInventorySpanEl.textContent = `Low Stock • Only ${stock} Left!`;
    }

    const bisFormFormEl = bisForm?.querySelector('#bis_form');

    if (bisFormFormEl) {
      bisFormFormEl.style.display = 'block';
    }

    const bisFormSuccess = bisForm?.querySelector('.product__bis-success-message');

    if (bisFormSuccess) {
      bisFormSuccess.style.display = 'none';
    }
  }

  getSaleSavingsPercent() {
    if (!this.currentVariant?.compare_at_price || this.currentVariant.compare_at_price <= this.currentVariant.price) {
      return null;
    }

    return Math.floor(100 - ((this.currentVariant.price / this.currentVariant.compare_at_price) * 100));
  }

  updateVariantContent(options = {}) {
    const skipPriceMarkup = options.skipPriceMarkup === true;
    const mainProductContainer = this.closest('[data-main-product-wrapper]');
    if (mainProductContainer) {
      mainProductContainer.classList.remove(
        'preview-discontinued',
        'preview-exclusive',
        'selection-discontinued-hover-lock',
        'selection-price-hover-lock'
      );
    }
    let metafieldData = this.getVariantMetafieldData();

    if (this.currentVariant) {
      var variantID = this.currentVariant.id.toString();
    } else {
      document.querySelector('label.product__color-label.active__option')?.click();
      this.dispatchEvent(new Event('change'));
    }

    metafieldData = metafieldData[0][variantID];

    if (this.currentVariant) {
      this.updateSkuDisplay(metafieldData);
    }

    this.querySelectorAll('[data-product-current-option]').forEach((element, index) => {
      element.textContent = this.currentVariant?.options[index];
    });

    const price = mainProductContainer.querySelector('[data-product-price]');

    if (price && !skipPriceMarkup && this.currentVariant) {
      if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        const discountPercent = this.getSaleSavingsPercent();
        price.innerHTML = `
          <p class="new-price">${formatMoney(this.currentVariant.price, '${{amount}}')}</p>
          <s class="regular-price">${formatMoney(this.currentVariant.compare_at_price, '${{amount}}')}</s>
          <p class="product__sale-badge">sale ${discountPercent}% off</p>
        `;
      } else {
        price.innerHTML = `
          <p>${formatMoney(this.currentVariant.price, '${{amount}}')}</p>
        `;
      }
    }

    const prefix = 'status';
    const classes = mainProductContainer.className.split(' ').filter(c => !c.startsWith(prefix));
    mainProductContainer.className = classes.join(' ').trim();

    if (metafieldData?.hasOwnProperty('variant_status')) {
      const statusHandle = metafieldData['variant_status'].replace(/\s+/g, '-').toLowerCase()
      mainProductContainer.classList.add(`status-${statusHandle}`)
    }

    const exclusiveMessage = typeof metafieldData?.exclusive === 'string' ? metafieldData.exclusive.trim() : '';
    const hasExclusiveMessage = exclusiveMessage.length > 0;
    const exclusiveWrapper = mainProductContainer.querySelector('.product__exclusive-wrapper')

    if (exclusiveWrapper) {
      exclusiveWrapper.innerHTML = hasExclusiveMessage ? `<p class='product__text exclusive_message'>${exclusiveMessage}</p>` : ''
    }

    if (metafieldData) {
      mainProductContainer.classList.toggle('status-exclusive', hasExclusiveMessage)
      if (hasExclusiveMessage) {
        mainProductContainer.classList.remove('status-out-of-stock', 'status-low-stock');
      }
    }

    const variantStatusInput = mainProductContainer.querySelector('[data-variant-status]');

    if (variantStatusInput) {
      variantStatusInput.value = metafieldData?.hasOwnProperty('variant_status') ? metafieldData['variant_status'] : '';
      variantStatusInput.disabled = !metafieldData?.hasOwnProperty('variant_status');
    }

    const inventoryElements = {
      oosInventoryEl: mainProductContainer.querySelector('.out-of-stock.inventory'),
      inStockInventoryEl: mainProductContainer.querySelector('.in-stock.inventory'),
      warningInventoryEl: mainProductContainer.querySelector('.warning-stock.inventory'),
      bisForm: mainProductContainer.querySelector('.product__bis-form'),
      availableInEl: document.querySelector('.product__available-in'),
      exclusiveWrapper,
    };

    const isComingSoon = this.isComingSoonVariant(metafieldData);
    const isDiscontinuedVariant = this.isDiscontinuedVariant(metafieldData);

    this.syncBuyButtons(metafieldData, mainProductContainer);

    if (isDiscontinuedVariant) {
      this.applyDiscontinuedAvailability(mainProductContainer, inventoryElements);
    } else if (!hasExclusiveMessage && !isComingSoon && metafieldData?.hasOwnProperty('stock')) {
      this.applyStockAvailability(metafieldData, mainProductContainer, inventoryElements);
    }

    if (this.currentVariant
      && this.currentVariant.compare_at_price > this.currentVariant.price
      && !mainProductContainer.classList.contains('status-clearance')
      && !isDiscontinuedVariant
    ) {
      const savingsText = mainProductContainer.querySelector('[data-product-sale-savings]');
      const savingsPercentage = this.getSaleSavingsPercent();
      mainProductContainer.classList.add('status-sale')

      if (savingsText) {
        savingsText.innerText = `${savingsPercentage}%`;
      }
    }

    //UPDATE PATTERN PRODUCTS GOES HERE
    if (metafieldData?.hasOwnProperty("product_type")) {
      if (metafieldData["product_type"] == 'Pattern') {
        let totalPrice = 0;
        const patternLink = metafieldData['pattern_download'];
        const downloadButton = document.querySelector('.download-pattern-btn');
        const disabledKitGroup = document.querySelector('.disabled-kit .product-group');
        const totalPriceElements = document.querySelectorAll('.total-price-amount');
        const addToCartButton = document.querySelector('.disabled-kit #add-to-cart');

        if (downloadButton) {
          downloadButton.setAttribute('href', patternLink);
        }

        const patternItems = metafieldData['patternVariants'];
        let stepCount = 1;
        let hasAccessories = false;

        let accessoriesHTML = '<span class="product-variations-title"><span class="product-variations-title-number"><span class="product-variations-title-number-text">{{stepCount}}</span></span><span class="product-variation-title-name-text" role="heading">Accessories</span></span><div class="custom-kit-colors" id="custom-kit-accessories-' + (this ? this.dataset.section : '') + '"><div class="items">';
        let selectorsHTML = '<span class="product-variations-title"><span class="product-variations-title-number"><span class="product-variations-title-number-text">{{stepCount}}</span></span><span class="product-variation-title-name-text" role="heading">Select Colors</span></span><div class="custom-kit-colors js-kit" id="custom-kit-colors-' + (this ? this.dataset.section : '') + '"><div class="items">';
        const disablePatternVariant = patternItems.some(value => value.product_status === 'Discontinued' || value.variant_status === 'Limited Edition') || ['Discontinued', 'Archived (patterns only)', 'Limited Edition'].includes(metafieldData.product_status);

        if (disablePatternVariant) {
          if (disabledKitGroup) disabledKitGroup.style.display = 'none';
          if (addToCartButton) addToCartButton.setAttribute('disabled', true);
        } else {
          if (disabledKitGroup) disabledKitGroup.style.display = 'block';
          if (addToCartButton) addToCartButton.removeAttribute('disabled');
        }

        patternItems.forEach((value, index) => {
          const image = value.product_type === 'Tools & Accessories' ?
            `<img src="${value.product_image}" alt=""/>` :
            `<img src="${value.variant_image}" alt=""/>`;

          const labelTitle = value.variant_title === 'Default Title' ?
            value.product_title :
            value.variant_title;
          const escapedLabelTitle = String(labelTitle ?? '')
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');

          const title = `<span class="contrast-name-current-value">${escapedLabelTitle}</span>`;

          const bothTitles = value.variant_title !== 'Default Title' ?
            `<a href="${value.product_url}" class="contrast-name-current">${value.product_title}</a>` : '';

          let qtyValue = Math.min(parseInt(value.inventory), value.required_qty ? parseInt(value.required_qty) : 1);

          if (value.variant_status === 'Coming Soon' || value.variant_status === 'Debug') {
            qtyValue = 0;
          }

          const insufficientInventory = parseInt(value.inventory) < parseInt(value.required_qty) ? 'style="display: inline-block;"' : 'style="display: none;"';

          const inventoryMessage = `
            <p class="discontinued-stock inventory" ${value.product_status == 'Discontinued' ? '' : 'hidden'}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> 
                <path d="M9.5625 0C7.67122 0 5.82241 0.560831 4.24986 1.61157C2.67732 2.66231 1.45167 4.15577 0.727906 5.90309C0.00414312 7.65041 -0.185226 9.57311 0.183745 11.4281C0.552716 13.283 1.46346 14.9869 2.8008 16.3242C4.13814 17.6615 5.84201 18.5723 7.69695 18.9413C9.5519 19.3102 11.4746 19.1209 13.2219 18.3971C14.9692 17.6733 16.4627 16.4477 17.5134 14.8751C18.5642 13.3026 19.125 11.4538 19.125 9.5625C19.122 7.02728 18.1136 4.59675 16.3209 2.80408C14.5283 1.01141 12.0977 0.00297736 9.5625 0ZM18 9.5625C18.0018 11.6057 17.2589 13.5795 15.9103 15.1144L4.01063 3.21469C5.22986 2.14667 6.73105 1.45265 8.3345 1.21572C9.93794 0.978782 11.5757 1.20897 13.0517 1.87872C14.5277 2.54848 15.7794 3.62942 16.657 4.99215C17.5346 6.35487 18.0009 7.94164 18 9.5625ZM1.125 9.5625C1.12318 7.51932 1.8661 5.54552 3.21469 4.01062L15.1144 15.9103C13.8952 16.9783 12.394 17.6723 10.7905 17.9093C9.18707 18.1462 7.54931 17.916 6.0733 17.2463C4.59728 16.5765 3.34556 15.4956 2.46798 14.1329C1.59039 12.7701 1.12413 11.1834 1.125 9.5625Z" fill="#2D2B4C"/>
              </svg>
              Discontinued
            </p>

            <p class="out-of-stock inventory" ${parseInt(value.inventory) > 0 && value.variant_status !== 'Debug' ? 'hidden' : ''}>
              <svg style="enable-background:new 0 0 24 24;" width="15" height="15" version="1.1" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path fill="#961852" d="M5.3,18.7C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4   l5.3,5.3l-5.3,5.3C4.9,17.7,4.9,18.3,5.3,18.7z"/>
              </svg>
              Out of Stock
            </p>

            <p class="warning-stock inventory" ${value.variant_status === 'Debug' || parseInt(value.inventory) < 1 || parseInt(value.inventory) > 30 ? 'hidden' : ''}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0.4375C8.10872 0.4375 6.25991 0.998331 4.68736 2.04907C3.11482 3.09981 1.88917 4.59327 1.16541 6.34059C0.441643 8.08791 0.252274 10.0106 0.621245 11.8656C0.990216 13.7205 1.90096 15.4244 3.2383 16.7617C4.57564 18.099 6.27951 19.0098 8.13445 19.3788C9.9894 19.7477 11.9121 19.5584 13.6594 18.8346C15.4067 18.1108 16.9002 16.8852 17.9509 15.3126C19.0017 13.7401 19.5625 11.8913 19.5625 10C19.5595 7.46478 18.5511 5.03425 16.7584 3.24158C14.9658 1.44891 12.5352 0.440477 10 0.4375ZM10 18.4375C8.33122 18.4375 6.69992 17.9426 5.31238 17.0155C3.92484 16.0884 2.84338 14.7706 2.20477 13.2289C1.56616 11.6871 1.39907 9.99064 1.72463 8.35393C2.05019 6.71721 2.85379 5.21379 4.03379 4.03379C5.2138 2.85378 6.71722 2.05019 8.35393 1.72462C9.99064 1.39906 11.6871 1.56615 13.2289 2.20477C14.7706 2.84338 16.0884 3.92484 17.0155 5.31238C17.9427 6.69992 18.4375 8.33122 18.4375 10C18.435 12.237 17.5453 14.3817 15.9635 15.9635C14.3817 17.5453 12.237 18.435 10 18.4375ZM9.4375 10.75V5.5C9.4375 5.35082 9.49677 5.20774 9.60226 5.10225C9.70775 4.99676 9.85082 4.9375 10 4.9375C10.1492 4.9375 10.2923 4.99676 10.3978 5.10225C10.5032 5.20774 10.5625 5.35082 10.5625 5.5V10.75C10.5625 10.8992 10.5032 11.0423 10.3978 11.1477C10.2923 11.2532 10.1492 11.3125 10 11.3125C9.85082 11.3125 9.70775 11.2532 9.60226 11.1477C9.49677 11.0423 9.4375 10.8992 9.4375 10.75ZM10.9375 14.125C10.9375 14.3104 10.8825 14.4917 10.7795 14.6458C10.6765 14.8 10.5301 14.9202 10.3588 14.9911C10.1875 15.0621 9.99896 15.0807 9.81711 15.0445C9.63525 15.0083 9.4682 14.919 9.33709 14.7879C9.20598 14.6568 9.11669 14.4898 9.08052 14.3079C9.04434 14.126 9.06291 13.9375 9.13387 13.7662C9.20482 13.5949 9.32499 13.4485 9.47916 13.3455C9.63333 13.2425 9.81458 13.1875 10 13.1875C10.2486 13.1875 10.4871 13.2863 10.6629 13.4621C10.8387 13.6379 10.9375 13.8764 10.9375 14.125Z" fill="#AD1F04"/>
              </svg>

              Hurry, only ${value.inventory} left!
            </p>

            <p class="in-stock inventory"  ${(parseInt(value.inventory) <= 30) || value.variant_status === 'Debug' ? 'hidden' : ''}>
              <svg class="feather feather-check" fill="none" height="15" stroke="#00a424" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="15" xmlns="http://www.w3.org/2000/svg">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              In Stock
            </p>

            <p class="coming-soon inventory"  ${value.variant_status === 'Coming Soon' ? '' : 'hidden'} ${value.variant_status === 'Coming Soon' ? 'style="display: flex;"' : ''}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0.4375C8.10872 0.4375 6.25991 0.998331 4.68736 2.04907C3.11482 3.09981 1.88917 4.59327 1.16541 6.34059C0.441643 8.08791 0.252274 10.0106 0.621245 11.8656C0.990216 13.7205 1.90096 15.4244 3.2383 16.7617C4.57564 18.099 6.27951 19.0098 8.13445 19.3788C9.9894 19.7477 11.9121 19.5584 13.6594 18.8346C15.4067 18.1108 16.9002 16.8852 17.9509 15.3126C19.0017 13.7401 19.5625 11.8913 19.5625 10C19.5595 7.46478 18.5511 5.03425 16.7584 3.24158C14.9658 1.44891 12.5352 0.440477 10 0.4375ZM10 18.4375C8.33122 18.4375 6.69992 17.9426 5.31238 17.0155C3.92484 16.0884 2.84338 14.7706 2.20477 13.2289C1.56616 11.6871 1.39907 9.99064 1.72463 8.35393C2.05019 6.71721 2.85379 5.21379 4.03379 4.03379C5.2138 2.85378 6.71722 2.05019 8.35393 1.72462C9.99064 1.39906 11.6871 1.56615 13.2289 2.20477C14.7706 2.84338 16.0884 3.92484 17.0155 5.31238C17.9427 6.69992 18.4375 8.33122 18.4375 10C18.435 12.237 17.5453 14.3817 15.9635 15.9635C14.3817 17.5453 12.237 18.435 10 18.4375ZM9.4375 10.75V5.5C9.4375 5.35082 9.49677 5.20774 9.60226 5.10225C9.70775 4.99676 9.85082 4.9375 10 4.9375C10.1492 4.9375 10.2923 4.99676 10.3978 5.10225C10.5032 5.20774 10.5625 5.35082 10.5625 5.5V10.75C10.5625 10.8992 10.5032 11.0423 10.3978 11.1477C10.2923 11.2532 10.1492 11.3125 10 11.3125C9.85082 11.3125 9.70775 11.2532 9.60226 11.1477C9.49677 11.0423 9.4375 10.8992 9.4375 10.75ZM10.9375 14.125C10.9375 14.3104 10.8825 14.4917 10.7795 14.6458C10.6765 14.8 10.5301 14.9202 10.3588 14.9911C10.1875 15.0621 9.99896 15.0807 9.81711 15.0445C9.63525 15.0083 9.4682 14.919 9.33709 14.7879C9.20598 14.6568 9.11669 14.4898 9.08052 14.3079C9.04434 14.126 9.06291 13.9375 9.13387 13.7662C9.20482 13.5949 9.32499 13.4485 9.47916 13.3455C9.63333 13.2425 9.81458 13.1875 10 13.1875C10.2486 13.1875 10.4871 13.2863 10.6629 13.4621C10.8387 13.6379 10.9375 13.8764 10.9375 14.125Z" fill="#AD1F04"/>
              </svg>
              Coming Soon
            </p>
          `;



          const itemHTML = `
            <div class="contrast clearfix" data-index="${index}">
              <div class="contrast-mobile-top">
                <div class="contrast-image">${image}</div>

                <div class="contrast-right-global">
                  <span class="contrast-name-vendor section-title">
                    ${value.product_vendor}
                  </span>

                  <div class="contrast-name-top contrast-name-top--${value.variant_id}">
                    ${title}

                    ${value.product_type != 'Tools & Accessories' ?
                      `
                        <div class="contrast-swatch" data-value="${value.variant_title}"></div>

                        <modal-opener class="colors-modal" data-modal="#ColorSelect-${index}">
                          <button
                            class="open-color-modal contrast-name-change-color"
                            aria-haspopup="dialog"
                            data-variant-color="${value.variant_title}"
                            data-product-type="pattern"
                            data-open-color-modal="#ColorSelect-${index}"
                            aria-label="Change Color"
                            type="button"
                          >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21.1781 7.01068L16.9884 2.82099C16.8666 2.6991 16.7219 2.60241 16.5626 2.53644C16.4034 2.47048 16.2327 2.43652 16.0603 2.43652C15.8879 2.43652 15.7173 2.47048 15.558 2.53644C15.3988 2.60241 15.2541 2.6991 15.1322 2.82099L3.57188 14.3822C3.44975 14.5039 3.35292 14.6486 3.28695 14.8079C3.22098 14.9672 3.18718 15.138 3.1875 15.3104V19.5001C3.1875 19.8482 3.32578 20.182 3.57192 20.4281C3.81807 20.6743 4.15191 20.8126 4.5 20.8126H8.68969C8.8621 20.8129 9.03287 20.7791 9.19216 20.7131C9.35145 20.6471 9.49611 20.5503 9.61781 20.4282L21.1781 8.86693C21.3 8.74505 21.3967 8.60036 21.4627 8.44111C21.5286 8.28186 21.5626 8.11118 21.5626 7.93881C21.5626 7.76643 21.5286 7.59575 21.4627 7.4365C21.3967 7.27725 21.3 7.13256 21.1781 7.01068ZM8.82188 19.6322C8.78688 19.6675 8.73934 19.6873 8.68969 19.6876H4.5C4.45027 19.6876 4.40258 19.6678 4.36742 19.6326C4.33226 19.5975 4.3125 19.5498 4.3125 19.5001V15.3104C4.31271 15.2607 4.3326 15.2132 4.36781 15.1782L12.75 6.79506L17.2041 11.2501L8.82188 19.6322ZM20.3822 8.07193L18 10.4541L13.5459 6.00006L15.9281 3.61693C15.9455 3.5995 15.9662 3.58567 15.989 3.57623C16.0117 3.5668 16.0361 3.56194 16.0608 3.56194C16.0854 3.56194 16.1098 3.5668 16.1326 3.57623C16.1553 3.58567 16.176 3.5995 16.1934 3.61693L20.3822 7.80662C20.3996 7.82403 20.4135 7.84471 20.4229 7.86747C20.4323 7.89024 20.4372 7.91463 20.4372 7.93927C20.4372 7.96391 20.4323 7.98831 20.4229 8.01108C20.4135 8.03384 20.3996 8.05452 20.3822 8.07193Z" fill="#2D2B4C"/>
                            </svg>
                          </button>
                        </modal-opener>
                      `
                    :
                      ''
                    }
                  </div>

                  <div class="contrast-name">${bothTitles}</div>

                  <div style="width: 100%;">
                    <span class="contrast-qty-required-warning-message" ${insufficientInventory}>This pattern requires at least ${value.required_qty} ball.</span>
                  </div>

                  <div class="availability-msg">${inventoryMessage}</div>
                </div>
              </div>

              <div class="contrast-actions">
                <div class="contrast-right quantity-price ${disablePatternVariant || value.inventory < 1 || value.variant_status === 'Coming Soon' || value.variant_status === 'Debug' ? 'quantity-price--soldout' : ''}">
                  <div class="contrast-qty-container">
                    <product-quantity-input class="product__quantity">
                      <button class="product__quantity-button" name="minus" type="button">
                        <span class="visually-hidden">
                          Decrease ${escapedLabelTitle} quantity
                        </span>

                        <span class="svg-wrapper">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z" fill="#2D2B4C"/>
                          </svg>
                        </span>
                      </button>

                      <input
                        class="product__quantity-input contrast-qty"
                        type="number"
                        name="quantity"
                        min="0"
                        data-min="0"
                        onChange="qtyChangeFunction(this)"
                        data-variant-id="${value.variant_id}"
                        data-quantity-required="${value.required_qty}"
                        data-component-type="contrast"
                        data-pattern-quantity-input
                        max="${value.inventory}"
                        value="${qtyValue}"
                        step="1"
                        aria-label="${escapedLabelTitle} quantity"
                        readonly
                      >

                      <button class="product__quantity-button" name="plus" type="button">
                        <span class="visually-hidden">
                          Increase ${escapedLabelTitle} quantity
                        </span>

                        <span class="svg-wrapper">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H12.75V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H11.25V3.75C11.25 3.55109 11.329 3.36032 11.4697 3.21967C11.6103 3.07902 11.8011 3 12 3C12.1989 3 12.3897 3.07902 12.5303 3.21967C12.671 3.36032 12.75 3.55109 12.75 3.75V11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z" fill="#2D2B4C"/>
                          </svg>
                        </span>
                      </button>
                    </product-quantity-input>
                  </div>

                  <div class="contrast-price non-active">
                    <span class="contrast-price-sep">x</span>
                    <div class="product-price">
                      <span class="price-sales" data-price="${value.price}">$${(value.price / 100.0).toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;

          if (value.product_type === 'Tools & Accessories') {
            hasAccessories = true;
            accessoriesHTML += itemHTML;
          } else {
            selectorsHTML += itemHTML;
          }

          var itemTotalPrice = qtyValue * value.price;
          totalPrice += itemTotalPrice;
        });

        document.querySelectorAll('.product-option-select').forEach(function () {
          stepCount += 1;
        });

        accessoriesHTML += '</div></div>';
        selectorsHTML += '</div></div>';
        selectorsHTML = selectorsHTML.replace('{{stepCount}}', stepCount);

        if (hasAccessories) {
          stepCount += 1;
          accessoriesHTML = accessoriesHTML.replace('{{stepCount}}', stepCount);
          selectorsHTML += accessoriesHTML;
        }

        var customKitGroup = document.querySelector('#custom-kit-variations .product-group');

        if (customKitGroup) {
          customKitGroup.innerHTML = selectorsHTML;
        }

        totalPriceElements.forEach((totalPriceElement) => {
          totalPriceElement.textContent = '$' + (totalPrice / 100.0).toFixed(2);
        });

        checkOutOfStockInventory();
        setPatternSwatches();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    // Quick-add modals render this same product markup over a collection/search page — the user
    // never actually navigated here, so swapping the address bar to the product URL is misleading
    // and (since this is replaceState, not pushState) would make a refresh load the wrong page
    // entirely while the modal is open.
    if (this.closest('quick-add-modal')) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput(variantId) {
    const resolvedVariantId = variantId ?? this.currentVariant?.id;
    if (!resolvedVariantId) return;

    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;

      input.value = resolvedVariantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');

    if (!section) return;

    const productForm = section.querySelector('product-form');

    if (productForm) productForm.handleErrorMessage();
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);

    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    addButtonText.textContent = text;

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;

    if (price) {
      price.classList.add('visibility-hidden');
    }

    if (inventory) {
      inventory.classList.add('visibility-hidden');
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent).variant;
    return this.variantData;
  }

  getVariantMetafieldData() {
    this.variantMetafieldData = this.variantMetafieldData || JSON.parse(this.querySelector('[type="application/json"]').textContent).metafields;
    return this.variantMetafieldData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
        const radioButtons = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        if (radioButtons.length > 0) {
            const checkedRadio = radioButtons.find((radio) => radio.checked);
            return checkedRadio ? checkedRadio.value : null;
        }

        const selectElement = fieldset.querySelector('select');
        if (selectElement) {
            return selectElement.value;
        }

        return null;
    }).filter(Boolean);
  }
}

customElements.define('variant-radios', VariantRadios);

class ShowModalColor extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.close-color-modal').forEach(closeBtn => {
      closeBtn.addEventListener('click', () => {
        this.close();
      });
    })

    this.checkIfPopulated();
  }

  checkIfPopulated() {
    const variantSwatches = this.querySelectorAll('[data-variant-swatch]');
    const modalOpener = document.querySelector(`modal-opener[data-modal="${this.dataset.colorsModal}"]`);

    if (!modalOpener) { return; }

    modalOpener.toggleAttribute('hidden', variantSwatches.length < 1);
  }

  show(opener) {
    this.openedBy = opener;
    trapFocusInModal(this);
  }

  close(){
    this.removeAttribute('open');
    cancelTrappedFocusInModal(this);
    if(this.openedBy){
      this.openedBy.focus();
    }
  }
}
customElements.define('show-modal-color', ShowModalColor);

function setPatternSwatches() {
  const contrastSwatches = document.querySelectorAll('.contrast-swatch');

  contrastSwatches.forEach((swatch) => {
    const index = swatch.closest('.contrast').getAttribute('data-index');
    const variantTitle = swatch.getAttribute('data-value');
    const modal = document.querySelector(`show-modal-color[data-index="${index}"]`);

    if (!modal) { return; }

    const matchingSwatch = modal.querySelector(`[data-variant-swatch][data-variant-title="${variantTitle}"]`);

    if (!modal || !matchingSwatch) { return; }

    swatch.style.backgroundImage = `url(${matchingSwatch.getAttribute('data-variant-swatch')})`;
  });
}

setPatternSwatches();

/***** Product Variants JS end *****/
function patternChangeFunction(e) {
  const selectedValue = e.querySelector(":selected").value;
  const inputName = e.id;

  // Update the value of the corresponding input field
  const inputElement = document.querySelector(`.product__form-input [name="${inputName}"]`);
  if (inputElement) {
    inputElement.value = selectedValue;

    // Trigger the 'change' event
    const changeEvent = new Event('change', { bubbles: true });
    inputElement.dispatchEvent(changeEvent);

    // Find and trigger 'click' and 'change' events on the corresponding option
    const optionElement = inputElement.querySelector(`[value="${selectedValue}"]`);
    if (optionElement) {
      const clickEvent = new Event('click', { bubbles: true });
      optionElement.dispatchEvent(clickEvent);

      const changeOptionEvent = new Event('change', { bubbles: true });
      optionElement.dispatchEvent(changeOptionEvent);
    }
  }
}

function qtyChangeFunction(el) {
  let totalPrice = 0;

  const quantityRequired = parseInt(el.getAttribute('data-quantity-required'), 10);
  const inputValue = parseInt(el.value, 10);

  if (inputValue < quantityRequired) {
    el.closest('.contrast')
      .querySelector('.contrast-qty-required-warning-message')
      .style.display = 'inline-block';
  } else {
    el.closest('.contrast')
      .querySelector('.contrast-qty-required-warning-message')
      .style.display = 'none';
  }

  document.querySelectorAll('.quantity-price').forEach((element) => {
    const quantity = parseInt(element.querySelector('.contrast-qty').value, 10);
    const price = parseFloat(element.querySelector('.price-sales').getAttribute('data-price'));

    totalPrice += quantity * price;
  });

  const totalPriceElements = document.querySelectorAll('.total-price-amount');

  totalPriceElements.forEach((totalPriceElement) => {
    totalPriceElement.textContent = `$${(totalPrice / 100).toFixed(2)}`;
  });
}

document.addEventListener('click', (event) => {
  if (!event.target.hasAttribute('data-pattern-atc')) { return; }
  patternAddToCart(event.target);
});

function patternAddToCart(){
  let formData = { items: [] };

  document.querySelectorAll('.contrast .contrast-qty').forEach((element) => {
    const quantity = parseInt(element.value, 10);
    const variantId = element.getAttribute('data-variant-id');
    const patternTitle = document.querySelector('.product__title').textContent.split(',')[0];

    if (quantity > 0) {
      formData.items.push({
        quantity,
        id: parseInt(variantId, 10),
        properties: { Pattern: patternTitle },
      });
    }
  });

  console.log(formData);

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
  .then((response) => {
    if (response.ok) {
      updateCart(response);
    } else {
      console.error('Error adding items to the cart:', response.statusText);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

class ProductQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.buttons = this.querySelectorAll('button');
  }

  connectedCallback() {
    this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const cartItem = this.closest('[data-product]');
    const quantityWarning = cartItem?.querySelector('[data-product-quantity-warning]');

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else if (parseInt(this.input.getAttribute('max')) < (parseInt(this.input.value) + 1)) {
        if (quantityWarning) {
          quantityWarning.classList.remove('hide');
        }
      } else {
        this.input.stepUp();

        if (quantityWarning) {
          quantityWarning.classList.add('hide');
        }
      }
    } else {
      this.input.stepDown();

      if (quantityWarning) {
        quantityWarning.classList.add('hide');
      }
    }

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }

    this.input.dispatchEvent(new Event('change'));
  }
}

customElements.define('product-quantity-input', ProductQuantityInput);

/***** BV tabs start *****/
document.addEventListener('DOMContentLoaded', function (e) {
  var bvTabsToggle = document.querySelectorAll('.bv-app-tabs .tab a');
  var bvTabsContent = document.querySelectorAll('.bv-app-tabs .tab-content');
  bvTabsToggle.forEach((tabToggle) => {
    tabToggle.addEventListener('click', function (e) {
      e.preventDefault();
      bvTabsToggle.forEach((allTabToggle, index) => {
        allTabToggle.parentElement.classList.remove('is-active');
        bvTabsContent[index].classList.remove('is-active');
      });
      var tabsContentHref = this.getAttribute('href');
      var tabsContent = document.querySelector(tabsContentHref);
      tabsContent.classList.add('is-active');
      this.parentElement.classList.add('is-active');
    });
  });
});
/***** BV tabs end *****/